var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import eventBus from '../../utils/fresh-table';
import simpleTable from '../../components/ins-manage/simple-table.vue';
export default Vue.extend({
    components: {
        simpleTable: simpleTable,
    },
    data: function () {
        var _this = this;
        return {
            channelId: '',
            requestConfig: {
                url: '/proxy/carInsOrder/fee/download/list',
                method: 'post',
                params: {
                    type: 4,
                },
            },
            otherConfig: {
                lazyLoad: true,
            },
            tableConfig: [
                {
                    label: '序号',
                    prop: 'id',
                    width: '280px',
                },
                {
                    label: '导出时间',
                    prop: 'createTime',
                    width: '240px',
                },
                {
                    label: '状态',
                    prop: 'status',
                    width: '220px',
                    formatter: function (val) {
                        var statusName = '未知状态';
                        switch (val) {
                            case 0:
                                statusName = '未开始';
                                break;
                            case 1:
                                statusName = '进行中';
                                break;
                            case 2:
                                statusName = '已完成';
                                break;
                            case 3:
                                statusName = '失败';
                                break;
                        }
                        return statusName;
                    },
                },
                {
                    label: '操作',
                    prop: 'ope_control_group',
                    minWidth: '100px',
                    fixed: 'right',
                    btns: [
                        {
                            name: '下载',
                            callback: function (row) {
                                _this.doDownload(row);
                            },
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        // 获取channelId
        fetchChannelId: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$request({
                                url: '/proxy/carInsurance/channel/getInfo',
                                method: 'get',
                                data: {},
                            }).then(function (res) {
                                if (!res)
                                    return;
                                if (res.errorCode)
                                    return;
                                return res.data;
                            })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        transTableData: function (res, pageInfo) {
            var totalElements = res.data.pageInfo.totalElements;
            var pageSize = pageInfo.pageSize, pageNo = pageInfo.pageNo;
            return {
                pageNo: pageNo,
                pageSize: pageSize,
                totalItemCount: totalElements,
                data: res.data.tasks,
            };
        },
        doDownload: function (row) {
            this.getDownloadUrl(row.downloadUri);
        },
        // 获取下载地址接口
        getDownloadUrl: function (uri) {
            // 1:保单导出 2:费用清单导出 4:续保保单导出
            var params = {
                uri: uri,
            };
            this.$request({
                url: '/proxy/carInsOrder/fee/download/getUrl',
                method: 'get',
                data: params,
            }).then(function (res) {
                if (!res)
                    return;
                if (res.errorCode)
                    return;
                location.href = res.data.download_url;
            });
        },
        loadTable: function () {
            this.requestConfig.params = {
                channelId: this.channelId,
                type: 4,
            };
            eventBus.$emit('freshSimpleTable');
        },
    },
    mounted: function () {
        var _this = this;
        this.fetchChannelId().then(function (data) {
            _this.channelId = data.channelId;
            _this.loadTable();
        });
    },
});
